import { t } from "@lingui/macro";
import { Divider, Grid, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Form, Formik } from "formik";
import capitalize from "lodash/capitalize";
import React from "react";

import { ProfileDateOfBirthFilterEnum, ProfileMaritalStatusEnum } from "@/saleor/api";

import GenericDialog from "../shared/dialog/GenericDialog";
import { CheckboxGroupField, DropdownField, InputField } from "../shared/fields";

const GENDERS = [];
const MARITAL_STATUSES = ["MARRIED", "SINGLE", "DIVORCED", "SEPARATED", "WIDOWED"];
const BIRTH_DAYS = [
	{ value: "ALL", label: t`All` },
	{ value: "THIS_WEEK", label: t`This Week` },
	{ value: "NEXT_WEEK", label: t`Next Week` },
	{ value: "THIS_MONTH", label: t`This Month` },
	{ value: "NEXT_MONTH", label: t`Next Month` },
	{ value: "THREE_MONTHS", label: t`Next Three Months` },
];

export interface FilerOptions {
	gender: string[];
	maritalStatus: ProfileMaritalStatusEnum | string;
	birthday: ProfileDateOfBirthFilterEnum | string;
	startAge: number;
	endAge: number;
	residency: string;
	nationality: string;
	goals: string;
	tags: string;
}

export interface ClientFilterDialogProps {
	onClose: () => void;
	isOpen: boolean;
	filters?: FilerOptions | null;
	applyFilter: (filters: FilerOptions | null) => void;
}

const ClientFilterDialog = ({ filters, applyFilter, ...others }: ClientFilterDialogProps) => {
	const handleSubmit = (values: FilerOptions) => {
		applyFilter(values);
	};

	const handleReset = () => {
		applyFilter(null);
	};

	const GENDERS = [
		{
			value: "MALE",
			label: t`Male`,
		},
		{
			value: "FEMALE",
			label: t`Female`,
		},
	];

	const MRS = MARITAL_STATUSES.map((v) => ({ label: t`${capitalize(v)}`, value: v }));
	const BD = BIRTH_DAYS.map((v) => ({
		label: v.label,
		value: v.value,
	}));
	return (
		<GenericDialog {...others} maxWidth="md" title={t`Select Recipients to Shop for`}>
			<Box width="100%" px={2} pb={2} pt={1}>
				<Formik
					initialValues={{
						gender: ["MALE", "FEMALE"],
						maritalStatus: "",
						birthday: "ALL",
						startAge: 0,
						endAge: 99,
						residency: "",
						nationality: "",
						goals: "",
						tags: "",
						...filters,
					}}
					onSubmit={handleSubmit}
				>
					{({ submitForm }) => (
						<Form>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Stack
										direction="row"
										spacing={2}
										justifyContent="flex-end"
										divider={
											<Divider
												orientation="vertical"
												className="my-1"
												flexItem
											/>
										}
									>
										<Button
											onClick={handleReset}
											size="small"
										>{t`Clear`}</Button>
										<Button
											onClick={submitForm}
											color="primary"
											variant="contained"
											size="small"
										>{t`Apply Filter`}</Button>
									</Stack>
								</Grid>
								<Grid item xs={12} md={6}>
									<CheckboxGroupField
										label={t`Gender`}
										name="gender"
										data={GENDERS}
									/>
								</Grid>

								<Grid item xs={12} md={6}>
									<DropdownField
										label={t`Marital Status`}
										data={MRS}
										name="maritalStatus"
										defaultText={t`Select...`}
									/>
								</Grid>
								<Grid item xs={6} md={3}>
									<InputField
										label={t`Start Age`}
										name="startAge"
										type="number"
									/>
								</Grid>
								<Grid item xs={6} md={3}>
									<InputField label={t`End Age`} name="endAge" type="number" />
								</Grid>
								<Grid item xs={6} md={3}>
									<DropdownField label={t`Birthday`} data={BD} name="birthday" />
								</Grid>
								{/* <Grid item xs={6}>
                            <DropdownField
                                label={t`Residency`} data={BD}
                                name='residency'
                                defaultText={t`Select...`}
                            />
                        </Grid> */}
								{/* <Grid item xs={6}>
                            <DropdownField
                                label={t`Nationality`} data={BD}
                                name='nationality'
                                defaultText={t`Select...`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DropdownField
                                label={t`Goals`}
                                data={BD}
                                name='goals'
                                defaultText={t`Select...`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DropdownField
                                label={t`Tags`}
                                data={BD}
                                name='tags'
                                defaultText={t`Select...`}
                            />
                        </Grid> */}
							</Grid>
						</Form>
					)}
				</Formik>
			</Box>
		</GenericDialog>
	);
};

export default ClientFilterDialog;
